import React from 'react';
import PropTypes from 'prop-types';
// Components
import Button from '../../button';
// Styles
import { CountryModalInner, MapModal, Link } from './styles';
// Utils
import { propLink } from '../../link-handler';

const CountryModalContent = ({ countries, link, closeFn, thisMap }) => {
  const { thisCountry, thatCountry } = countries;

  return (
    <CountryModalInner>
      <MapModal src={thisMap} />
      <h4>{`This is Shelter ${thisCountry}`}</h4>
      <p>{`Housing law is different in ${thisCountry} and ${thatCountry}.`}</p>
      <Link
        $bg="primary"
        $fullWidth
        link={link}
        data={{ siteselect: thatCountry }}
      >
        {`Switch to ${thatCountry}`}
      </Link>
      <Button bg="secondary-outline" fullWidth onClick={closeFn}>
        {`Stay on ${thisCountry}`}
      </Button>
    </CountryModalInner>
  );
};

export default CountryModalContent;

CountryModalContent.propTypes = {
  link: propLink.isRequired,
  countries: PropTypes.shape({
    thisCountry: PropTypes.string,
    thatCountry: PropTypes.string,
  }).isRequired,
  closeFn: PropTypes.func.isRequired,
  thisMap: PropTypes.string.isRequired,
};
